module.exports = __webpack_public_path__ + "static/img/sg.5e6ed3f1.svg";